import React from 'react';
import Avatar from '@mui/material/Avatar';

const PRIMARY_COLORS = [
  '#2196F3', '#4CAF50', '#FF9800', '#F44336', '#9C27B0', '#00BCD4',
  '#FF5722', '#3F51B5', '#8BC34A', '#E91E63', '#795548', '#607D8B',
  '#FFC107', '#009688', '#673AB7', '#CDDC39',
];

function stringToColor(string) {
  let hash = 0;
  for (let i = 0; i < string.length; i++) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  return PRIMARY_COLORS[Math.abs(hash) % PRIMARY_COLORS.length];
}

function stringAvatar(name) {
  return {
    sx: { bgcolor: stringToColor(name) },
    children: `${name && name.length > 0 ? name.split(' ')[0][0].toUpperCase() : ''}${
      name && name.split(' ')[1] ? name.split(' ')[1][0].toUpperCase() : ''
    }`,
  };
}

export default function AgentAvatar({
  name,
  size = 28,
  borderRadius,
  fontSize,
  onClick,
  sx,
  children,
  ...rest
}) {
  const resolvedName = name || '?';
  const avatarProps = stringAvatar(resolvedName);
  const resolvedRadius = borderRadius ?? (size <= 24 ? `${Math.round(size * 0.2)}px` : '6px');
  const resolvedFontSize = fontSize ?? (size <= 20 ? '10px' : size <= 28 ? '12px' : size <= 40 ? '14px' : '20px');

  const clickSx = onClick
    ? {
        cursor: 'pointer',
        transition: 'transform 140ms ease, box-shadow 140ms ease',
        '&:hover': { transform: 'translateY(-1px)', boxShadow: '0 2px 8px rgba(24,24,27,0.2)' },
        '&:active': { transform: 'translateY(0)', boxShadow: '0 1px 4px rgba(24,24,27,0.16)' },
      }
    : {};

  return (
    <Avatar
      variant='rounded'
      {...avatarProps}
      {...rest}
      {...(children != null ? { children } : {})}
      onClick={onClick}
      sx={{
        ...avatarProps.sx,
        width: size,
        height: size,
        borderRadius: resolvedRadius,
        fontSize: resolvedFontSize,
        fontWeight: 600,
        flexShrink: 0,
        ...clickSx,
        ...sx,
      }}
    />
  );
}
